import React from "react"

import { Link, graphql, useStaticQuery } from "gatsby"
// import BackgroundImage from "gatsby-background-image"
// import { getImage } from "gatsby-plugin-image"
// import { convertToBgImage } from "gbimage-bridge"

import "./hero.css"

const BannerApproach = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(relativePath: { eq: "new-images/bg-approach.jpeg" }) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1920
  //             layout: CONSTRAINED
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  return (
    <>
      <div
        // Tag="div"
        // {...bgImage}
        className="hero-banner hero-whitefade-approach"
        // preserveStackingContext
        style={{ backgroundPosition: "center" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7 mr-auto">
              <div className="hero-procurement">
                <p className="h5 text-light-blue text-uppercase font-weight-bold mt-0 mb-4">
                  HOW IT WORKS
                </p>
                <h1 className="page-title font-weight-medium mt-0 mb-4">
                  We Build Custom Solutions in Weeks Using Our Agile Process
                </h1>
                <p>
                  Don’t wait 9-12 months for a solution you hope does the job.
                  We use low code and custom development to solve your biggest
                  business problems in weeks.
                </p>
                <p>
                  <Link
                    aria-label="link"
                    className="font-weight-medium"
                    to="/contact/"
                  >
                    Improve Your Systems
                    <i className="ml-2 item-arrow" aria-hidden="true"></i>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BannerApproach
